module.exports = __webpack_public_path__ + "static/media/takealot-logo.288442ff.jpg";